import { render, staticRenderFns } from "./ApprovalFrame.vue?vue&type=template&id=0c5999f6&scoped=true"
import script from "./ApprovalFrame.vue?vue&type=script&lang=js"
export * from "./ApprovalFrame.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFrame.vue?vue&type=style&index=0&id=0c5999f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5999f6",
  null
  
)

export default component.exports